<ng-container *ngSubscribe="linkedCardsCount$ as linkedCardsCount">
  <button
    class="btn add-card-link"
    [disabled]="cardLinkingSettings.allowMultipleCardLinking == false && linkedCardsCount > 0"
    (click)="openCardLinkingTerms(addNewCardTerms)"
  >
    <span class="icon material-icons">add_card</span>
    <label class="card-link-label">{{ 'fgbcl.card.linking.link.card.button.title' | translate }}</label>
  </button>
</ng-container>

<!--Terms and Conditions Modal-->
<ng-template #addNewCardTerms let-modal>
  <div class="container p-3 overflow-auto">
    <div class="d-flex justify-content-between align-items-center">
      <div class="font-size-14 fw-bold card-linking-terms-title">
        {{ 'fgbcl.card.linking.terms.title' | translate }}
      </div>
      <button class="btn p-0 card-link-terms-close-modal-button" (click)="modal.close(); isTermsAccepted = false">
        <span class="material-icons material-symbols-outlined card-linking-terms-close-icon">close</span>
      </button>
    </div>
    <hr class="card-linking-terms-modal-hr-tags" />
    <div class="d-flex">
      <div class="m-auto">
        <div class="card-linking-terms-icons-container">
          <div class="icon material-icons card-linking-terms-icon color-1 rounded-circle position-absolute">
            <span>credit_card</span>
          </div>
          <div class="icon material-icons card-linking-terms-icon color-2 rounded-circle position-absolute">
            <span>emoji_events</span>
          </div>
          <div class="icon material-icons card-linking-terms-icon color-3 rounded-circle position-absolute">
            <span>star</span>
          </div>
        </div>
      </div>
    </div>
    <div class="font-size-12 text-center px-5 card-linking-terms-description">
      {{ 'fgbcl.card.linking.terms.description' | translate }}
    </div>
    <hr class="card-linking-terms-modal-hr-tags" />
    <div class="card-linking-terms-content">
      <fgbcl-terms-and-conditions [type]="termsAndConditionsType"></fgbcl-terms-and-conditions>
    </div>
    <div class="d-flex mt-3 card-linking-terms-checkbox">
      <input class="Terms_Accepted_chk_box" type="checkbox" id="accepted" [(ngModel)]="isTermsAccepted" />
      <label for="accepted" class="d-inline-block font-size-12 ps-2 fw-bold mb-0 card-linking-accept-terms-label">
        {{ 'fgbcl.card.linking.accept.terms.label' | translate }}</label
      >
    </div>
    <div class="d-flex">
      <button class="card-linking-terms-next-btn btn" [disabled]="!isTermsAccepted" (click)="linkcard()">
        {{ 'fgbcl.card.linking.terms.next.btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<!-- <ng-template #addNewCardForm let-modal>
  <div class="container p-2 overflow-auto">
    <div class="m-2">
      <p class="fw-bold">{{ 'fgbcl.card.linking.link.offer.modal.title' | translate }}</p>
      <hr class="horizontal-line" />
    </div>
    <div class="header d-flex flex-row justify-content-center my-10">
      <button class="btn btn-success">{{ 'fgbcl.card.linking.model.active.offer.button.title' | translate }}</button>
    </div>
    <div class="container">
      <p class="fw-bold">{{ 'fgbcl.card.linking.model.activated.offer.button.title' | translate }}</p>
      <fgbcl-card-link-offers-list></fgbcl-card-link-offers-list>
    </div>
  </div>
</ng-template> -->
